import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { fetchAllData, MessagesEgdUserQuery, ResetSystemPassword } from '../models/Doctor';
import { ForgetDoctorPasswordModal } from '../models/Login';
import { doctor_register_api_data } from '../models/doctorregistration';
import { DoctorProfileUpdateDataSubmit } from '../models/Doctorprofile';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';
import { HttpParams } from "@angular/common/http";
import { PromiseResult } from '../models/PromiseResult';
import { Doctor_Termination_Model } from '../models/termination';
import { doctorprofileedit } from '../models/deditprofile';
import { GetMyPatientsQuery } from '../models/patient-profile';
import { User_Registration } from '../models/User';
import { OTP_Validate } from '../models/util.models';

@Injectable({
    providedIn: 'root'
})
export class DoctorsService {
    constructor(private readonly http: HttpClient) { }

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    GetHomePagedoctors(): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "GetAllForHomePageViewing").pipe(
            catchError(this.handleError)
        );
    };

    findUserList(param: MessagesEgdUserQuery): Observable<PromiseResult> {
        let params = new HttpParams();
        Object.keys(param).forEach(key => {
            if (param[key] != null) params = params.append(key, param[key].toString());
        })
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "GetAll/users/list", { params }).pipe(
            catchError(this.handleError)
        );
    }

    GetPatientsUniqueList(user_guid: string): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "GetPatients/unique/" + user_guid).pipe(
            catchError(this.handleError)
        );
    }

    createDoctor(formData: FormData): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.DoctorsApi + "create", formData)
            .pipe(
                catchError(this.handleError)
            );
    }

    updateDoctor(doctorData: DoctorProfileUpdateDataSubmit, user_guid: string): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.DoctorsApi + "Profile/Update/" + user_guid, doctorData)
            .pipe(
                catchError(this.handleError)
            );
    }

    forgotDoctorPassword(data: ForgetDoctorPasswordModal): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.DoctorsApi + "SendResetPasswordToken", data)
            .pipe(
                catchError(this.handleError)
            );
    }

    getDoctorprofile(user_guid: string): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "Get/" + user_guid)
            .pipe(
                catchError(this.handleError)
            );
    }

    getDoctorprofileedit(user_guid: string): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "Profile/Get/" + user_guid)
            .pipe(
                catchError(this.handleError)
            );
    }
    updateDoctorprofiledata(current_user_guid: string, Doctordata: doctorprofileedit): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.DoctorsApi + "Profile/Update/" + current_user_guid, Doctordata)
            .pipe(
                catchError(this.handleError)
            );
    }
    UploadDoctorProfilePhoto(form: FormData, user_guid: string): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.DoctorsApi + "Update/ProfilePhoto/" + user_guid, form)
            .pipe(
                catchError(this.handleError)
            );
    }

    UploadDoctorResume(form: FormData, user_guid: string): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.DoctorsApi + "Profile/Update/Resume/" + user_guid, form)
            .pipe(
                catchError(this.handleError)
            );
    }





    UploadSignature(form: FormData, user_guid: string): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.DoctorsApi + "Profile/Update/Signature/" + user_guid, form)
            .pipe(
                catchError(this.handleError)
            );
    }

    getDoctorIDCardData(user_guid: string): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "get/" + user_guid)
            .pipe(
                catchError(this.handleError)
            );
    }

    GetAllDoctors(): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "GetAll").pipe(catchError(this.handleError));
    }



    GetDoctorlist(): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "GetAll/Roles").pipe(catchError(this.handleError));
    }

    UpdateStatus(Doctor: Doctor_Termination_Model): Observable<PromiseResult> {
        return this.http.patch<PromiseResult>(RestApi.Urls.DoctorsApi + "Update/" + Doctor.user_guid + "/is_active", Doctor).pipe(catchError(this.handleError));
    }

    UpdateRolesandfeatured(user_guid: string, role_id: number, featured_doctor_id: boolean): Observable<PromiseResult> {
        return this.http.patch<PromiseResult>(RestApi.Urls.DoctorsApi + 'Update/' + user_guid + '/Roles/isfeatured',
            { role_id, featured_doctor_id })
            .pipe(catchError(this.handleError))
    }

    GetAllRoles(): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "Roles/GetAll").pipe(catchError(this.handleError));
    }

    GetLanguageSpoken(): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "Get/languages").pipe(catchError(this.handleError));
    }


    GetSysPassToken(data: ResetSystemPassword): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.DoctorsApi + "Get/PasswordToken", data).pipe(catchError(this.handleError));
    }


    ResetSysPass(data: ResetSystemPassword): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.DoctorsApi + "ResetPassword", data).pipe(catchError(this.handleError));
    }


    GetAllPatients(query: GetMyPatientsQuery): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.DoctorsApi + "GetPatients", query).pipe(catchError(this.handleError));
    }

    GetDoctorReportspdf(patient_guid: string, consultation_id: number, report_type: string): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.PatientAccountApi + "Get/" + patient_guid + "/Reports/" + consultation_id + "/" + report_type).pipe(catchError(this.handleError));
    }

    forgotEmail(user: User_Registration): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.DoctorsApi + "ForgotEmail", user)
            .pipe(
                catchError(this.handleError)
            )
    }

    fetchAgreement(): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "Agreement/fetch")
            .pipe(
                catchError(this.handleError)
            );
    }

    updateCredentialsMedProf(userid: string) {
        return this.http
            .post<PromiseResult>(RestApi.Urls.DoctorsApi + 'update/credentials', { data: userid })
            .pipe(catchError(this.handleError));
    }

    credentials_validate_or_resend_otp_MedProf(data: OTP_Validate) {
        return this.http
            .post<PromiseResult>(RestApi.Urls.DoctorsApi + 'update/credentials/validate', data)
            .pipe(catchError(this.handleError));
    }

    getFetchAllActiveUsers(body: fetchAllData) {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.DoctorsApi + "fetchAll/users/active", body
            )
            .pipe(catchError(this.handleError));
    }

    CreateDoctorCertificate(form: FormData): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.DoctorsApi + "certificates/create", form)
            .pipe(
                catchError(this.handleError)
            );
    }

    RemoveDoctorCertificate(id: string): Observable<PromiseResult> {
        return this.http.delete<PromiseResult>(RestApi.Urls.DoctorsApi + "certificates/delete/" + id)
            .pipe(
                catchError(this.handleError)
            );
    }

    GetDoctorOwnedCertificates() {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "certificates/get/owned")
            .pipe(
                catchError(this.handleError)
            );
    }

    GetPendingCertificates() {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + "certificates/get/pending")
            .pipe(
                catchError(this.handleError)
            );
    }

    VerifyDoctorCertificate(certificate_id: string): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.DoctorsApi + "certificates/verify/" + certificate_id, {})
            .pipe(
                catchError(this.handleError)
            );
    }

    DownloadDoctorCertificate(certificate_id: string, doctor_user_id: string) {
        return this.http.get<PromiseResult>(RestApi.Urls.DoctorsApi + 'certificates/download/' + doctor_user_id + '/' + certificate_id)
            .pipe(
                catchError(this.handleError)
            );
    }
}
